import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { platformChatService } from '../../../services/PlatformChatService';
import { chatQueryKeys } from '../chatQueryKeys';

export function usePlatformChatSessionQuery(
  sessionId: string | undefined,
  options?: { enabled?: boolean },
) {
  const { user } = useAuth();
  const resolvedSessionId = sessionId?.trim() ?? '';
  const isEnabled =
    (options?.enabled ?? true) && Boolean(user) && resolvedSessionId.length > 0;

  return useQuery({
    queryKey: chatQueryKeys.session(resolvedSessionId),
    enabled: isEnabled,
    queryFn: async () => {
      const session = await platformChatService.getSession(resolvedSessionId);
      return session ?? null;
    },
  });
}
